import { useWebappApi as re } from "../../providers/ApiProvider/ApiProvider.js";
import { cn as o } from "../../../lib/shadcn/utils/utils.js";
import { Dialog as ne, DialogContent as te, DialogDescription as $, DialogFooter as oe, DialogHeader as le, DialogTitle as q } from "../../../lib/shadcn/ui/components/dialog.js";
import { isMobileAppClient as ae, sendMessageToAppClient as x, startDashboardHeightMonitoring as ie } from "../../../helpers/mobile.helper.js";
import { DialogTypes as w } from "./Dialog.types.js";
import { useEffect as P, useImperativeHandle as ce, useMemo as ue, useRef as p, useState as se } from "react";
import { Fragment as F, jsx as r, jsxs as I } from "react/jsx-runtime";
import { VisuallyHidden as A } from "@radix-ui/react-visually-hidden";
function K(f) {
  const e = p(void 0);
  return P(() => {
    e.current = f;
  }, [f]), e.current;
}
var fe = ({ className: f, classNames: e, title: t, description: l, footer: H, image: M, children: V, dataTestid: z, open: a, onOpenChange: B, onDialogOpen: O, onDialogClose: E, showCloseButton: G = !0, onlyClosableViaButtons: J = !0, disableEscapeKeyDown: L, maxWidth: Q = 768, type: c = M ? w.image : w.none, showIcon: v = !0, fullScreen: U = !1, id: N, nativeOverlayType: i, hideTitle: d, hideDescription: D, stickyFooter: C = !1, ref: X, "aria-label": Y, ...m }) => {
  const [Z, b] = se(!1), y = K(a), R = K(i), u = p(!1), _ = p(null), s = p(null), { analytics: j } = re({ optional: !0 }) ?? {};
  ce(X, () => ({ trackAction: g })), P(() => {
    const n = a !== y, h = i !== R;
    if (n) {
      b(!!a), a ? (O?.(), g("overlay_open"), k(), u.current = !1, requestAnimationFrame(() => {
        s.current = ie(_.current);
      })) : y && !u.current && (E?.(), x("closeOverlay"), s.current?.(), s.current = null, u.current = !0);
      return;
    }
    a && h && k();
  }, [
    a,
    y,
    i,
    R
  ]);
  const k = () => {
    ae() && (x("openOverlay", i ? { type: i } : void 0), i && b(!1));
  }, T = (n) => {
    b(n), B?.(n), n ? (O?.(), g("overlay_open")) : u.current || (E?.(), x("closeOverlay"), s.current?.(), s.current = null, g("overlay_interact", ""), u.current = !0);
  }, g = (n, h) => {
    N && j && j.trackEvent({
      event: n,
      id: N,
      ...h !== void 0 && { action: h }
    });
  }, ee = { maxWidth: `${Q}px` }, S = H ? /* @__PURE__ */ r(oe, {
    sticky: C,
    className: o(e?.footer),
    children: H
  }) : null, W = ue(() => /* @__PURE__ */ I(le, {
    ...m,
    type: c,
    showIcon: v,
    className: o(e?.header),
    children: [
      t && d ? /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(q, {
        type: c,
        className: o(e?.title),
        children: t
      }) }) : null,
      t && !d ? /* @__PURE__ */ r(q, {
        type: c,
        className: o(e?.title),
        children: t
      }) : null,
      t ? null : /* @__PURE__ */ r("div", {
        "aria-hidden": "true",
        className: o("m-0 w-full min-w-0 leading-6", e?.title)
      }),
      D ? /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r($, {
        className: o(e?.description),
        children: l
      }) }) : /* @__PURE__ */ r($, {
        className: o(e?.description),
        children: l
      })
    ]
  }), [
    m,
    c,
    v,
    d,
    t,
    D,
    l,
    e
  ]);
  return /* @__PURE__ */ r(ne, {
    ...m,
    open: Z,
    onOpenChange: T,
    children: /* @__PURE__ */ I(te, {
      ...m,
      ...t ? {} : {
        "aria-label": typeof l == "string" ? l : Y,
        "aria-labelledby": void 0
      },
      fullscreen: U,
      type: c,
      image: M,
      showCloseButton: G,
      dataTestid: z,
      className: o(f, e?.root),
      classNames: { content: e?.description },
      style: ee,
      stickyFooter: C,
      footer: S,
      ref: _,
      onInteractOutside: J ? (n) => {
        n.preventDefault();
      } : void 0,
      onEscapeKeyDown: L ? (n) => {
        n.preventDefault();
      } : void 0,
      children: [
        (t || l) && /* @__PURE__ */ r(F, { children: d && D && !v ? /* @__PURE__ */ r(A, { children: W }) : /* @__PURE__ */ r(F, { children: W }) }),
        V,
        !C && S
      ]
    })
  });
};
fe.displayName = "Dialog";
export {
  fe as Dialog
};

//# sourceMappingURL=Dialog.js.map